import Breadcrumb from "../breadcrumb/breadcrumb";
import SEO from "../SEO/SEO";
import "./legal.css";

export default function Legal() {
  return (
    <section className="legal-section">
      <SEO
        title="Mentions Légales - Location Grand Hôtel Châtel-Guyon"
        description="Mentions légales, conditions générales et informations légales de Location Grand Hôtel Châtel-Guyon - Appartements et studios pour cure thermale."
        canonical="https://chatel-guyon-hotel-cure-thermes.fr/legal"
      />
      <Breadcrumb
        items={[{ label: "Accueil", url: "/" }, { label: "Mentions Légales" }]}
      />
      <h1>Mentions Légales</h1>

      <p>
        Conformément aux dispositions des articles 6-III et 19 de la loi n°
        2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique,
        nous vous informons de l'identité des différents intervenants dans le
        cadre de la réalisation et du suivi de ce site internet.
      </p>

      <h2>1. Éditeur et responsable de publication</h2>
      <p>
        <strong>Nom :</strong> Alexandre Bariguian
        <br />
        <strong>Adresse :</strong> 13 rue de la Grande Fontaine,
        Cournon-D'auvergne, France
        <br />
        <strong>Téléphone :</strong>{" "}
        <a href="tel:+33614101916">06 14 40 19 16</a>
        <br />
        <strong>Email :</strong> abariguian@icloud.com
        <br />
        <strong>Statut :</strong> Particulier
      </p>

      <h2>2. Hébergement du site</h2>
      <p>
        Le site est hébergé par :<br />
        <strong>OVH</strong>
        <br />
        Adresse : 2 rue Kellermann, 59100 Roubaix, France
        <br />
        Site web : https://www.ovh.com
      </p>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu de ce site (textes, images, photographies, logos,
        vidéos, structure, charte graphique) est la propriété exclusive de
        l'éditeur du site ou de ses partenaires. Toute reproduction,
        distribution, modification, adaptation, retransmission ou publication,
        même partielle, de ces différents éléments est strictement interdite
        sans l'accord exprès par écrit du propriétaire du site.
      </p>
      <p>
        Toute exploitation non autorisée du site ou d'un quelconque élément
        qu'il contient sera considérée comme constitutive d'une contrefaçon et
        poursuivie conformément aux dispositions des articles L.335-2 et
        suivants du Code de Propriété Intellectuelle.
      </p>

      <h2>4. Protection des données personnelles</h2>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD)
        et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, vous
        disposez d'un droit d'accès, de rectification, de suppression et
        d'opposition aux données personnelles vous concernant.
      </p>
      <p>
        Les informations collectées sur ce site sont uniquement destinées à la
        gestion des réservations et aux communications relatives à la location.
        Elles ne sont en aucun cas cédées à des tiers.
      </p>
      <p>
        Pour exercer vos droits, vous pouvez nous contacter par email à [votre
        email] ou par courrier postal à l'adresse indiquée ci-dessus.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Ce site n'utilise pas de cookies de suivi ou de publicité. Seuls des
        cookies techniques strictement nécessaires au fonctionnement du site
        peuvent être utilisés.
      </p>

      <h2>6. Liens hypertextes</h2>
      <p>
        Ce site peut contenir des liens vers des sites tiers (Airbnb,
        Booking.com, etc.). L'éditeur du site n'a aucun contrôle sur le contenu
        de ces sites externes et ne peut être tenu responsable de leur contenu
        ou de leurs pratiques.
      </p>

      <h2>7. Limitation de responsabilité</h2>
      <p>
        L'éditeur du site s'efforce d'assurer l'exactitude et la mise à jour des
        informations diffusées sur ce site. Toutefois, il ne peut garantir
        l'exactitude, la précision ou l'exhaustivité des informations mises à
        disposition sur ce site.
      </p>
      <p>
        En conséquence, l'éditeur décline toute responsabilité pour toute
        imprécision, inexactitude ou omission portant sur des informations
        disponibles sur le site.
      </p>

      <h2>8. Droit applicable</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. Tout
        litige relatif à l'utilisation du site sera soumis à la compétence
        exclusive des tribunaux français.
      </p>
    </section>
  );
}
